import { makeStyles } from 'tss-react/mui';

import mobileAppRequiredGraphic from '~/assets/icons/new/mobileAppRequired.svg';
import mobileAppRequiredOnStarGraphic from '~/assets/icons/new/mobileAppRequired_new.svg';
import alertImage1 from '../../../assets/images/alertMessage/alertImage1.jpg';
import alertImage4 from '../../../assets/images/alertMessage/alertImage4.jpg';
import defaultGraphic from '../../../assets/images/alertMessage/vanFrontView.png';
import bdLogoDark from '../../../assets/images/bdLogoDark.svg';

const useStyles = makeStyles()((theme) => ({
  body: {
    textAlign: 'center',
    color: theme.new.color.textSecondary,
    marginBottom: '16px',
  },
  logo: {
    backgroundImage: `url("${bdLogoDark}")`,
    backgroundSize: 'cover',
    width: '315px',
    height: '76px',
    margin: 'auto',
    marginBottom: theme.spacing(10),
  },
  alertTitle: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 0 16px',
    textAlign: 'center',
    width: '100%',
  },
  mobileAppRequiredContent: {
    gap: theme.new.spacing.large,
    width: '100%',
  },
  mobileAppRequiredBodyWrap: {
    alignSelf: 'stretch',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '567px',
    width: '100%',
  },
  mobileAppRequiredBody: {
    color: theme.new.color.textPrimary,
    marginBottom: 0,
    maxWidth: '567px',
    padding: `${theme.spacing(1.25)} ${theme.spacing(1.25)}`,
    textAlign: 'center',
    width: '100%',
  },
  alertMessageWrapper: {
    maxWidth: '1250px',
    margin: '10px auto',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      marginTop: '20px',
    },
    '& .alertMessageGraphic': {
      width: '415px',
      height: '460px',
      background: `url("${defaultGraphic}") 50% 50% no-repeat`,
      backgroundSize: 'auto 100%',
    },
    '&.topic_mobileAppRequired': {
      alignItems: 'center',
      backgroundColor: theme.new.color.background.page,
      boxSizing: 'border-box',
      justifyContent: 'center',
      margin: 0,
      maxWidth: '100%',
      minHeight: '100vh',
      padding: theme.new.spacing.medium,
      width: '100%',
      '& .alertTitleCopy': {
        color: theme.new.color.textPrimary,
        padding: 0,
      },
      '& > div': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '5rem',
        justifyContent: 'center',
        margin: '0 auto',
        maxWidth: '1200px',
        width: '100%',
      },
      '& > div > div': {
        width: 'auto',
      },
      '& .alertWrapper': {
        padding: 0,
        width: '100%',
      },
      '& .leftColumn': {
        flex: '1 1 567px',
        maxWidth: '567px',
        minWidth: 0,
        width: '100%',
      },
      '& .alertGraphicColumn': {
        alignItems: 'center',
        display: 'flex',
        flex: '0 0 auto',
        justifyContent: 'center',
        width: 'auto',
      },
      '& .alertMessageGraphic': {
        width: '522px',
        height: '584px',
        backgroundImage: `url("${mobileAppRequiredGraphic}")`,
        backgroundPosition: '50% 50%',
      },
      '&.mobileAppRequiredRebrand .alertMessageGraphic': {
        backgroundImage: `url("${mobileAppRequiredOnStarGraphic}")`,
      },
      '& .appStoreLogos': {
        gap: theme.spacing(2),
        justifyContent: 'center',
        '& > div:first-of-type': {
          marginRight: 0,
        },
      },
    },
    '&.topic_mobileAppRequired.showGraphic': {
      [theme.breakpoints.down('lg')]: {
        padding: theme.spacing(4),
        '& > div': {
          flexDirection: 'column',
          gap: theme.new.spacing.large,
        },
        '& > div > div': {
          width: '100%',
        },
        '& .alertGraphicColumn': {
          display: 'flex',
          flex: '0 0 auto',
          order: 1,
          paddingTop: theme.spacing(2.5),
          width: '100%',
        },
        '& .leftColumn': {
          order: 2,
        },
        '& .alertMessageGraphic': {
          aspectRatio: '248 / 300',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          height: 'auto',
          maxHeight: '300px',
          maxWidth: '248px',
          minHeight: 0,
          width: '100%',
        },
        '& .appStoreLogos': {
          flexWrap: 'wrap',
          gap: theme.spacing(1),
          justifyContent: 'center',
          maxWidth: '100%',
        },
        '& .mobileAppRequiredStack': {
          gap: theme.spacing(2),
        },
      },
    },
    '&.topic_logoutSuccess': {
      '& > div > div': {
        width: '50%',
      },
      '& .alertMessageGraphic': {
        height: '580px',
        width: '100%',
        backgroundPosition: '0 50%',
        backgroundImage: `url("${alertImage1}")`,
      },
    },
    '&.topic_pageNotFound': {
      '& > div > div': {
        width: '50%',
      },
      '& .alertMessageGraphic': {
        height: '580px',
        width: '100%',
        backgroundPosition: '0 50%',
        backgroundImage: `url("${alertImage4}")`,
      },
    },
    '&.topic_inviteRequired': {
      '& > div > div': {
        width: '50%',
      },
      '& .alertMessageGraphic': {
        height: '580px',
        width: '100%',
        backgroundPosition: '0 50%',
        backgroundImage: `url("${alertImage1}")`,
      },
    },
    '&.noGraphic': {
      '& > div > div.leftColumn': {
        width: '100%',
      },
    },
  },
  alertMessageContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.up('lg')]: {
      margin: '20px auto',
    },
  },
  alertMessageRightCol: {
    width: '40%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  alertMessageLeftCol: {
    width: '60%',
    [theme.breakpoints.down('lg')]: {
      width: '100% !important',
    },
    '& .alertWrapper': {
      padding: '0px',
      [theme.breakpoints.up('lg')]: {
        padding: '20px 30px',
      },
    },
    '& .appStoreLogos': {
      display: 'flex',
      '& > div:first-of-type': {
        marginRight: '10px',
      },
    },
  },
  imageContentContainer: {
    borderRadius: '8px',
    height: '206px',
    marginBottom: '53px',
    width: '320px',
  },
}));

export default useStyles;
